import React from 'react';
import { useSelector } from 'react-redux';
import { Modal, SaveButton, SystemText } from 'e4shared';
import Sorter from 'components/admin/forms/sorter';
import { apiPatch } from 'services';

export const SortAreas = ({ show, close, refresh, areas }) => {
    const user = useSelector(state => state.user.user);
    const [saving, setSaving] = React.useState(false);
    const [order, setOrder] = React.useState([]);

    const onSave = () => {
        const promises = [];

        order.forEach(c => {
            promises.push(apiPatch('competency-area', c, user.guid));
        });

        Promise.all(promises).then(() => {
            setTimeout(() => {
                refresh();
                close();
            }, 500);
        });
    };

    const footer = (
        <div className="pull-right">
            <SaveButton
                data-testid="button-save"
                saving={saving}
                setSaving={setSaving}
                className="btn btn-success"
                onClick={() => onSave()}
            >
                {SystemText('Admin/CompetencyAreas/SortAreas/Buttons/Save')}
            </SaveButton>
            <button data-testid="button-close" className="btn" onClick={() => close()}>
                {SystemText('Admin/CompetencyAreas/SortAreas/Buttons/Close')}
            </button>
        </div>
    );

    return (
        <Modal title={SystemText('Admin/CompetencyAreas/SortAreas/Modal/Title')} show={show} close={close} footer={footer}>
            <Sorter
                label={SystemText('Admin/CompetencyAreas/SortAreas/Sorter/Label')}
                help={SystemText('Admin/CompetencyAreas/SortAreas/Sorter/Help')}
                options={areas}
                onChange={options => setOrder(options)}
            />
        </Modal>
    );
};

export default SortAreas;
